import { CombinedGraphQLErrors } from '@apollo/client/errors'

export type ChannelReadDenial = 'forbidden' | 'notFound' | null

/**
 * Classify why a `channel(input)` read failed for the actor. The resolver gates
 * the read on `ViewChannel` (any non-`none` access) and *throws* rather than
 * returning a null channel — `FORBIDDEN` when the actor can't access the
 * channel, `NOT_FOUND` when the id doesn't resolve. Lets the single-channel
 * Insights page show the matching full-page state instead of an empty "no data"
 * shell. Transport / other failures return `null` (fall through to the normal
 * UI) so a transient blip isn't mislabelled as a permission or not-found state.
 */
export function getChannelReadDenial(error: unknown): ChannelReadDenial {
  if (!CombinedGraphQLErrors.is(error)) {
    return null
  }
  const hasCode = (code: string): boolean =>
    error.errors.some((graphQLError) => graphQLError.extensions?.code === code)
  if (hasCode('FORBIDDEN')) {
    return 'forbidden'
  }
  if (hasCode('NOT_FOUND')) {
    return 'notFound'
  }
  return null
}
